import CardHeader from '../../../antd/components/CardHeader';
import ModalDelete from '../../../Components/Shared/ModalDelete';
import { CreateRegisterModal } from "../../../Components/Register/CreateRegisterModal";
import { RegisterListVOModel } from "../../../Models/RegisterModel";
import { useEffect, useState } from "react";
import { GetAllByCompany, DeleteRegisterAPI } from "../../../API/RegisterAPI";
import { Link, useParams } from "react-router-dom";
import Loader from "../../../Components/Shared/Loader";
import useModal from "../../../Hooks/useModal";
import { toast } from "react-toastify";
import { Button, Table } from 'antd';
import { PlusOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons';
import type { ColumnsType } from 'antd/es/table';

const RegisterList = () => {
    const [showModal, setShowModal] = useState(false);
    const { showModal: showModalDelete, toggleShowModal: toggleShowModalDelete } = useModal();
    const [loading, setLoading] = useState(false);
    const [deleteResponse, setDeleteResponse] = useState<boolean>(false);
    const [itemToDelete, setItemToDelete] = useState<string>("");
    const [registerWithPercentage, setRegistersWithPercentage] = useState<RegisterListVOModel[]>([]);
    const [totalItems, setTotalItems] = useState<number>(0);
    const { id } = useParams();
    async function getRegisters(page?: number) {
        try {
            setLoading(true);
            const response = await GetAllByCompany(id ?? "", page);
            setRegistersWithPercentage(response.data.items);
            setTotalItems(response.data.total);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }
    const DeleteProjectHistory = async (registerId: string, companyId: string) => {
        try {
            setLoading(true);
            await DeleteRegisterAPI(registerId, companyId);
        } catch (error: any) {
            toast.error(error);
        } finally {
            setLoading(false);
            getRegisters();
        }
    }
    useEffect(() => {
        if (id) getRegisters();
    }, [id]);
    useEffect(() => {
        if (deleteResponse && itemToDelete) {
            const companyId = registerWithPercentage.find(item => item.register.id === itemToDelete)?.register.companyId;
            if (companyId) {
                DeleteProjectHistory(itemToDelete, companyId);
            }
            setItemToDelete("");
            setDeleteResponse(false);
        }
    }, [deleteResponse]);
    const columns: ColumnsType<RegisterListVOModel> = [
        {
            title: 'Versão',
            dataIndex: ['register', 'version'],
            key: 'version',
            sorter: (a, b) => b.register.version - a.register.version,
            render: (version) => `v${version}`,
            width: 100
        },
        {
            title: 'Banco de Fomento',
            dataIndex: ['register', 'bank', 'name'],
            key: 'bank',
            sorter: (a, b) => b.register.bank.name.localeCompare(a.register.bank.name),
            width: 200
        },
        {
            title: 'Painel Correspondente',
            dataIndex: ['register', 'opportunityPanel', 'name'],
            key: 'opportunityPanel',
            sorter: (a, b) => b.register.opportunityPanel.name.localeCompare(a.register.opportunityPanel.name),
            width: 400
        },
        {
            title: 'Porcentagem Conclusão',
            dataIndex: 'percentage',
            key: 'percentage',
            sorter: (a, b) => b.percentage - a.percentage,
            render: (percentage) => `${percentage} %`,
            width: 200
        },
        {
            title: 'Ano Referência',
            dataIndex: ['register', 'opportunityPanel', 'year'],
            key: 'year',
            sorter: (a, b) => b.register.opportunityPanel.year - a.register.opportunityPanel.year,
            width: 200,
        },
        {
            title: 'Ações',
            key: 'actions',
            align: 'center',
            width: 100,
            render: (_, record) => (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12}}>
                    <Link to={`/registrationFinep/${record.register.id}/${id}`}>
                        <EditOutlined style={{ fontSize: '18px'}} />
                    </Link>
                    <Button type="text" onClick={() => { setItemToDelete(record.register.id); toggleShowModalDelete(); }}>
                        <DeleteOutlined style={{ fontSize: '18px', color: 'red'}} />
                    </Button>
                </div>
            ),
        }
    ];
    return (
        <>
            {loading && <Loader />}
            <ModalDelete show={showModalDelete} toggleShow={toggleShowModalDelete} setResponse={setDeleteResponse} />
            <div className='card ml-2 mr-2'>
                <CardHeader pageName={"Cadastro"} hasPageBefore={false} />
                <div className='card-body'>
                    <Button type="primary" className="w-100 mb-4" onClick={() => setShowModal(true)}>
                        <PlusOutlined /> Novo Cadastro
                    </Button>
                    <Table
                        columns={columns}
                        dataSource={registerWithPercentage}
                        rowKey={record => record.register.id}
                        pagination={{
                            total: totalItems,
                            pageSize: 10,
                            onChange: (page) => getRegisters(page)
                        }}
                        loading={loading}
                    />
                </div>
            </div>
            <CreateRegisterModal setShowModal={setShowModal} showModal={showModal} getRegisters={getRegisters} />
        </>
    );
}
export default RegisterList;